import {Control as OLControl} from 'ol/control'
import {Map, View} from 'ol';
import {toLonLat, fromLonLat} from 'ol/proj';
import { unByKey } from 'ol/Observable';

// var StreetViewControl = /*@__PURE__*/(function (Control) {

// 	/**
// 	 * Es un control personalizado.
// 	 * @constructor
// 	 * @extends ol.control.Control
// 	 * @see http://openlayers.org/en/latest/apidoc/ol.control.Control.html
// 	 * @param {Object} opt_options - Opciones al crear el control personalizado
// 	 * @param {HTMLElement} [opt_options.element] - Solo se necesita si se crea un control heredando de este.
// 	 * @param {HTMLElement} [opt_options.target] - El elemento en el que se quiere incrustar el control.
// 	 * Si no se especifica, será el propio mapa.
// 	 * @param {ol.Map} opt_options.map - REQUERIDO. El mapa sobre el que se quiere incrustar Street View.
// 	 * @param {string} opt_options.className - El atributo 'class' usado para el botón.
// 	 * Usado para agregar CSS propio.
// 	 * @param {callback} opt_options.onPositionChange - Este callback se ejecuta
// 	 * cuando se cambia la posicion en Street View.
// 	 *
// 	 * @callback
// 	 * @param {Array<number>} coords - Array de coordenadas coords[0] = latitud. coords[1] = longitud
// 	 * @param {Object} data - Datos de la peticion al servicio de Street View Service.
// 	 * @param {string} status - Estado de la peticion a Street View Service.
// 	 * Contiene si se encuentran datos para unas coordenadas o si por el contrario
// 	 * no se encontraron daos validos o si hubo un error.
// 	 *
// 	 */
//     function StreetViewControl(opt_options = {}) {
//         let options = opt_options ? opt_options : {};

//         let isPressed = false;
//         let initialMapClass = "";
//         let evtKey = null;
//         let map = null;
// 		let elID = "control-sv";

//         /** @method getMap
//          * @desc devuelve el mapa al que está unido la instancia del control.
//          */
//         this.getMap = function(){
//             return options.map;
//         }

//         this.getOptions = function(){
//             return options;
//         }

//         if(options.className === undefined || options.className === null){
//             if(options.target === undefined || options.className === null){
//                 options.className = "ol-control street-view-control";
//             }
//             else if(!(options.target instanceof HTMLElement)){
//                 throw new TypeError("'target': must be string.");
//             }
//             else{
//                 options.className = "";
//             }
//         }
//         else if(typeof options.className !== "string"){
//             throw TypeError("className: Tipo de parametro inválido.");
//         }

//         if(!(options.map instanceof Map)){
//             throw new TypeError("'map' must be type of ol.Map");
//         }

//         map = options.map;
//         let mapContainer = map.getTargetElement();
//         // initialMapClass = mapContainer.className;
//         // mapContainer.className += " cursor-def";

//         var this_ = this;

//         this._turnOff = function(ev){
//             isPressed = false;
//             // mapContainer.className = initialMapClass;
//             // element.className = element.className.replace(" active", "");
//             mapContainer.classList.remove("cursor-sv");
//             element.classList.remove("active");
//             unByKey(evtKey);
//         };

//         this.toggleStreetView = function(ev){
//             if(!isPressed){
//                 isPressed = true;
//                 mapContainer.classList.add("cursor-sv");
//                 element.classList.add("active");
// 				// $('#' + elID).find($(".fas")).removeClass('fa-street-view').addClass('fa-times');
//                 evtKey = map.on("click", function(ev){
//                     let coords = ev.coordinate;
//                     let _onPositionChange = options.onPositionChange;
// 					let _onNoValidLocalion = options.onNoValidLocalion;

//                     this_.setStreetView({
//                         /** @type {Array<number>} coordenadas para street view */
//                         coords: coords,
//                         /** @type {ol.Map} mapa de OpenLayers.
//                          * Si se pasa el mapa, la vista se actualizará
//                          * según te mueves por Street View
//                          */
//                         onBeforeOpen: options.onBeforeOpen,
//                         onClosed: options.onClosed,
//                         map: map,
//                         update: options.update,
//                         /** @type {function} callback */
//                         onPositionChange: _onPositionChange,
// 						onNoValidLocalion: _onNoValidLocalion
//                     },
//                     function(success) {
//                         if(success){
//                             // mapContainer.className = initialMapClass;
//                             // element.className = element.className.replace(" active", "");
//                             // isPressed = false;
//                             // unByKey(evtKey);
//                             this_._turnOff();
//                         }
//                     });
//                 });
//             }else{
//                 this_._turnOff();
//                 // isPressed = false;
//                 // mapContainer.className = initialMapClass;
//                 // element.className = element.className.replace(" active", "");
//                 // unByKey(evtKey);
// 				// $('#' + elID).find($(".fas")).removeClass('fa-times').addClass('fa-street-view');
//             }
//             if(typeof options.onToggle === "function"){
//                 options.onToggle(isPressed, this_);
//             }
//         }

//         //Criar elemento personalizado
//         let element = document.createElement("div");
//         element.className = options.className;
//         element.id = elID;

//         if(options.content === undefined){
//             element.textContent = "SV";
//         }
//         else if(options.content instanceof HTMLElement){
//             element.appendChild(options.content);
//         }
//         else{
//             throw TypeError("content: must be string or HTMLElement");
//         }

//         // Addd button click
//         element.addEventListener("click", this.toggleStreetView, false);

//         Control.call(this_, {
//             element: element,
//             target: options.target
//         });

//         // options.map.addControl(this_);
//     }

//     if ( Control ) {
//         StreetViewControl.__proto__ = Control;
//     }

//     StreetViewControl.prototype = Object.create( Control && Control.prototype );
//     StreetViewControl.prototype.constructor = StreetViewControl;

//     StreetViewControl.prototype.forceClose = function () {
//         let map = this.getMap();
//         let panorama = map.panorama;
//         if(panorama){
//             panorama.setVisible(false);
//         }
//         this._turnOff();
//         if(typeof this.getOptions().onClosed === "function"){
//             this.getOptions().onClosed();
//         }

//     };

//     StreetViewControl.prototype.convertCoords = function convertCoords (coords) {
//         let coordinate = toLonLat([coords[0],coords[1]], this.getMap().getView().getProjection().getCode());
//         let latLng = {lat: coordinate[1], lng: coordinate[0]};
//         return latLng;
//     };

//     StreetViewControl.prototype.setStreetView = function setStreetView (params = {}, callback) {

//         if(params.coords === undefined || !Array.isArray(params.coords || params.coords.length !== 2))
// 		{
//             throw Error("Valid coordinates must be passed");
//         }

//         if((params.update !== undefined && params.update !== null) && typeof params.update !== "boolean")
// 		{
//             throw TypeError("The parameter 'update' is not valid");
//         }

//         if(params.map === undefined || !(params.map instanceof Map))
// 		{
//             throw Error("A valid map must be passed");
//         }

//         if(params.onPositionChange !== undefined && typeof params.onPositionChange !== "function")
// 		{
//             throw typeError("The onPositionChange function is not a valid function");
//         }

// 		 if(params.onNoValidLocalion !== undefined && typeof params.onNoValidLocalion !== "function")
// 		{
//             throw typeError("The onNoValidLocalion function is not a valid function");
//         }

//         let success = false;
//         let coords = this.convertCoords(params.coords);
//         let map = params.map;
//         let update = params.update || false;

// 		if (!(typeof google === 'object' && typeof google.maps === 'object' && typeof google.maps.StreetViewService === 'function'))
// 		{
// 			throw Error("Google Maps API is not loaded.");
// 		}

//         const sv_service = new google.maps.StreetViewService();

//         // Set the initial Street View camera to the center of the map
//         sv_service.getPanorama({location: coords, radius: 50}, processSVData);

//         function processSVData(data, status) {
//             if(status === google.maps.StreetViewStatus.OK){
//                 let mapContainer = map.getTargetElement();

//                 if(typeof params.onBeforeOpen === "function"){
//                     params.onBeforeOpen();
//                 }

//                 let panorama = map.panorama;
//                 if(panorama !== undefined)
//                 {
//                     panorama.setPosition(coords);
//                     panorama.setVisible(true);
//                 }
//                 else
//                 {
//                     panorama = new google.maps.StreetViewPanorama(mapContainer, {
//                         position: coords,
//                         visible: true
//                     });

//                     panorama.setEnableCloseButton(true);

//                     //Event when changing position in Street View
//                     panorama.addListener("position_changed", function(){
//                         if(update){
//                             let position = this.getPosition();
//                             //let coords = fromLonLat([position.lng(),position.lat()], "EPSG:3857");
//                             let coords = fromLonLat([position.lng(),position.lat()], map.getView().getProjection().getCode());
//                             map.getView().setCenter(coords);
//                         }

//                         if(typeof params.onPositionChange === "function"){
//                             params.onPositionChange(coords, data, status);
//                         }
//                     });

//                     map.panorama = panorama;

//                     panorama.addListener("closeclick", function()
//                     {
//                         if(typeof params.onClosed === "function"){
//                             params.onClosed();
//                         }
//                     });
//                 }

//                 success = true;

//             }else {
//                 // If you cannot find images for the request of some coordinates
//                 //alert("No valid location found here");
//                 if(typeof params.onNoValidLocalion === "function"){
//                     params.onNoValidLocalion();
//                 }
//             }

//             // Execute the callback if it is a function
//             if(typeof callback === "function") {
//                 callback(success);
//             }
//         }
//     };

//     return StreetViewControl;
// }(Control));

class StreetViewControl extends OLControl {
    constructor(args = {}) {
        let options = args;
        let isPressed = false;
        let initialMapClass = "";
        let evtKey = null;
        let map = null;
		let elID = "control-sv";


        //Criar elemento personalizado
        let element = document.createElement("div");
        element.className = options.className;
        element.id = elID;

        if(options.content === undefined){
            element.textContent = "SV";
        }
        else if(options.content instanceof HTMLElement){
            element.appendChild(options.content);
        }
        else{
            throw TypeError("content: must be string or HTMLElement");
        }

        super({
            element: element,
            target: options.target
        });

        /** @method getMap
         * @desc devuelve el mapa al que está unido la instancia del control.
         */
        this.getMap = function(){
            return options.map;
        }

        this.getOptions = function(){
            return options;
        }

        if(options.className === undefined || options.className === null){
            if(options.target === undefined || options.className === null){
                options.className = "ol-control street-view-control";
            }
            else if(!(options.target instanceof HTMLElement)){
                throw new TypeError("'target': must be string.");
            }
            else{
                options.className = "";
            }
        }
        else if(typeof options.className !== "string"){
            throw TypeError("className: Tipo de parametro inválido.");
        }

        if(!(options.map instanceof Map)){
            throw new TypeError("'map' must be type of ol.Map");
        }

        map = options.map;
        let mapContainer = map.getTargetElement();
        // initialMapClass = mapContainer.className;
        // mapContainer.className += " cursor-def";

        var this_ = this;

        this._turnOff = function(ev){
            isPressed = false;
            // mapContainer.className = initialMapClass;
            // element.className = element.className.replace(" active", "");
            mapContainer.classList.remove("cursor-sv");
            element.classList.remove("active");
            unByKey(evtKey);
        };

        this.toggleStreetView = function(ev){
            if(!isPressed){
                if(typeof options.onBeforeOpen === "function"){
                    options.onBeforeOpen();
                }

                isPressed = true;
                mapContainer.classList.add("cursor-sv");
                element.classList.add("active");
				// $('#' + elID).find($(".fas")).removeClass('fa-street-view').addClass('fa-times');
                evtKey = map.on("click", function(ev){
                    let coords = ev.coordinate;
                    let _onPositionChange = options.onPositionChange;
					let _onNoValidLocalion = options.onNoValidLocalion;

                    this_.setStreetView({
                        /** @type {Array<number>} coordenadas para street view */
                        coords: coords,
                        /** @type {ol.Map} mapa de OpenLayers.
                         * Si se pasa el mapa, la vista se actualizará
                         * según te mueves por Street View
                         */
                        onBeforeOpen: options.onBeforeOpen,
                        onClosed: options.onClosed,
                        map: map,
                        update: options.update,
                        /** @type {function} callback */
                        onPositionChange: _onPositionChange,
						onNoValidLocalion: _onNoValidLocalion
                    },
                    function(success) {
                        if(success){
                            // mapContainer.className = initialMapClass;
                            // element.className = element.className.replace(" active", "");
                            // isPressed = false;
                            // unByKey(evtKey);
                            this_._turnOff();
                        }
                    });
                });
            }else{
                this_._turnOff();
                // isPressed = false;
                // mapContainer.className = initialMapClass;
                // element.className = element.className.replace(" active", "");
                // unByKey(evtKey);
				// $('#' + elID).find($(".fas")).removeClass('fa-times').addClass('fa-street-view');
            }
            if(typeof options.onToggle === "function"){
                options.onToggle(isPressed, this_);
            }
        }

        // Addd button click
        element.addEventListener("click", this.toggleStreetView, false);
    }
}

StreetViewControl.prototype.forceClose = function () {
    let map = this.getMap();
    let panorama = map.panorama;
    if(panorama){
        panorama.setVisible(false);
    }
    this._turnOff();
    if(typeof this.getOptions().onClosed === "function"){
        this.getOptions().onClosed();
    }

};

StreetViewControl.prototype.convertCoords = function convertCoords (coords) {
    let coordinate = toLonLat([coords[0],coords[1]], this.getMap().getView().getProjection().getCode());
    let latLng = {lat: coordinate[1], lng: coordinate[0]};
    return latLng;
};

StreetViewControl.prototype.setStreetView = function setStreetView (params = {}, callback) {

    if(params.coords === undefined || !Array.isArray(params.coords || params.coords.length !== 2))
    {
        throw Error("Valid coordinates must be passed");
    }

    if((params.update !== undefined && params.update !== null) && typeof params.update !== "boolean")
    {
        throw TypeError("The parameter 'update' is not valid");
    }

    if(params.map === undefined || !(params.map instanceof Map))
    {
        throw Error("A valid map must be passed");
    }

    if(params.onPositionChange !== undefined && typeof params.onPositionChange !== "function")
    {
        throw typeError("The onPositionChange function is not a valid function");
    }

     if(params.onNoValidLocalion !== undefined && typeof params.onNoValidLocalion !== "function")
    {
        throw typeError("The onNoValidLocalion function is not a valid function");
    }

    let success = false;
    let coords = this.convertCoords(params.coords);
    let map = params.map;
    let update = params.update || false;

    if (!(typeof google === 'object' && typeof google.maps === 'object' && typeof google.maps.StreetViewService === 'function'))
    {
        throw Error("Google Maps API is not loaded.");
    }

    const sv_service = new google.maps.StreetViewService();

    // Set the initial Street View camera to the center of the map
    sv_service.getPanorama({location: coords, radius: 50}, processSVData);

    function processSVData(data, status) {
        if(status === google.maps.StreetViewStatus.OK){
            let mapContainer = map.getTargetElement();

            let panorama = map.panorama;
            if(panorama !== undefined)
            {
                panorama.setPosition(coords);
                panorama.setVisible(true);
            }
            else
            {
                panorama = new google.maps.StreetViewPanorama(mapContainer, {
                    position: coords,
                    visible: true
                });

                panorama.setEnableCloseButton(true);

                //Event when changing position in Street View
                panorama.addListener("position_changed", function(){
                    if(update){
                        let position = this.getPosition();
                        //let coords = fromLonLat([position.lng(),position.lat()], "EPSG:3857");
                        let coords = fromLonLat([position.lng(),position.lat()], map.getView().getProjection().getCode());
                        map.getView().setCenter(coords);
                    }

                    if(typeof params.onPositionChange === "function"){
                        params.onPositionChange(coords, data, status);
                    }
                });

                map.panorama = panorama;

                panorama.addListener("closeclick", function()
                {
                    if(typeof params.onClosed === "function"){
                        params.onClosed();
                    }
                });
            }

            success = true;

        }else {
            // If you cannot find images for the request of some coordinates
            //alert("No valid location found here");
            if(typeof params.onNoValidLocalion === "function"){
                params.onNoValidLocalion();
            }
        }

        // Execute the callback if it is a function
        if(typeof callback === "function") {
            callback(success);
        }
    }
};

export default StreetViewControl;